import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUserDescipline } from '../api/get-descipline';

export const fetchDescipline = createAsyncThunk(
  'userProfile/fetchDescipline',
  async (_, thunkAPI) => {
    try {
      return await getUserDescipline();
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
